import filter from 'lodash/filter'
import sumBy from 'lodash/sumBy'
import type { Payment } from '@ztechapps/common.contract'
import { PaymentStatusEnum } from '@ztechapps/common.contract'
import { roundNumber } from '../round-number/'

/**
 * Payment.status values that count toward an order's totalPaid — the single
 * source mirrored from ComputePaymentBalance. The AR aging aggregation and the
 * statement/aging totals pipelines MUST use this list so accounting numbers
 * stay in lockstep with the order screens.
 */
export const QUALIFYING_PAID_PAYMENT_STATUSES: PaymentStatusEnum[] = [
  PaymentStatusEnum.paid,
  PaymentStatusEnum.partiallyPaid,
  PaymentStatusEnum.partiallyRefunded,
  PaymentStatusEnum.adjusted,
]

export type ComputeOrderPaymentBalanceArgs = { net?: number; payments?: Payment[] }
export type ComputeOrderPaymentBalanceResult = { balance: number; totalPaid: number }

/**
 * Net minus the gross of payments in a qualifying-paid status, both rounded to 2dp.
 * Single source for the order and purchase-order balance actions — keeps order
 * screens, invoices, and AR pipelines computing the same number.
 */
export const computeOrderPaymentBalance = ({ net, payments }: ComputeOrderPaymentBalanceArgs): ComputeOrderPaymentBalanceResult => {
  const paidPayments = filter(payments ?? [], (payment) => QUALIFYING_PAID_PAYMENT_STATUSES.includes(payment?.status))
  const totalPaid = roundNumber(
    sumBy(paidPayments, (payment) => payment?.gross ?? 0),
    2
  )
  return { totalPaid, balance: roundNumber((net ?? 0) - totalPaid, 2) }
}
